import { render, staticRenderFns } from "./suntwo.vue?vue&type=template&id=fb98bed2&scoped=true"
import script from "./suntwo.vue?vue&type=script&lang=js"
export * from "./suntwo.vue?vue&type=script&lang=js"
import style0 from "./suntwo.vue?vue&type=style&index=0&id=fb98bed2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb98bed2",
  null
  
)

export default component.exports